import React from 'react'
import styled from 'styled-components'

import DegredationIcon from '@zendeskgarden/svg-icons/src/16/alert-warning-fill.svg'
import OutageIcon from '@zendeskgarden/svg-icons/src/16/alert-error-fill.svg'
import OkIcon from '@zendeskgarden/svg-icons/src/16/check-circle-fill.svg'
import MaintIcon from '@zendeskgarden/svg-icons/src/16/notification-fill.svg'
import NoticeIcon from '@zendeskgarden/svg-icons/src/16/alert-error-stroke.svg'


const StyledDegredationIcon = styled(DegredationIcon)`
  color: #FFB648
  margin-top: .14em;
`

const StyledOutageIcon = styled(OutageIcon)`
  color: #E35B66
  margin-top: .14em;
`

const StyledOkIcon = styled(OkIcon)`
  color: #5EAE91
  margin-top: .14em;
`

const StyledMaintIcon = styled(MaintIcon)`
  color: #3a9bbc
  margin-top: .14em;
`

const StyledNoticeIcon = styled(NoticeIcon)`
  color: #3a9bbc
  margin-top: .14em;
`

const EmptyDiv = styled.div`
  margin-top: .14em;
`

const StatusIcon = ({ status }) => {
  if (status === 'outage') {
    return <StyledOutageIcon/>
  } else if (status ==='degradation') {
    return <StyledDegredationIcon/>
  } else if (status === 'normal') {
    return <StyledOkIcon/>
  } else if (status === 'maintenance') {
    return <StyledMaintIcon />
  } else if (status === 'notice') {
    return <StyledNoticeIcon />
  }
  return <EmptyDiv/>
}

export default StatusIcon
